import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BaseService} from 'src/app/core/services/base.service';
import {UrlConstant} from '../constant/url.class';

@Injectable({
  providedIn: 'root'
})
export class MfaService extends BaseService {
  private readonly baseUrl = UrlConstant.API_VERSION;

  /**
   * Bước 2 của luồng login: xác thực OTP + mfaToken → nhận OAuth2 access_token.
   * POST /auth/verify-mfa  { mfaToken, otp }
   */
  public verifyMfa(mfaToken: string, otp: string): Observable<any> {
    const url = this.baseUrl + UrlConstant.VERIFY_MFA;
    return this.post(url, {mfaToken, otp});
  }

  /**
   * Lấy trạng thái 2FA của user đang đăng nhập.
   * GET /auth/mfa/status
   */
  public getMfaStatus(): Observable<any> {
    const url = this.baseUrl + UrlConstant.MFA_STATUS;
    return this.get(url);
  }

  /**
   * Khởi tạo 2FA: sinh secret mới, lưu PENDING, trả QR code URL.
   * POST /auth/mfa/setup
   */
  public setupMfa(): Observable<any> {
    const url = this.baseUrl + UrlConstant.MFA_SETUP;
    return this.post(url, {});
  }

  /**
   * Xác nhận OTP để kích hoạt 2FA (PENDING → ENABLED).
   * POST /auth/mfa/verify-setup  { otp }
   */
  public verifySetup(otp: string): Observable<any> {
    const url = this.baseUrl + UrlConstant.MFA_VERIFY_SETUP;
    return this.post(url, {otp});
  }

  /**
   * Tắt 2FA sau khi xác nhận OTP hợp lệ.
   * POST /auth/mfa/disable  { otp }
   */
  public disableMfa(otp: string): Observable<any> {
    const url = this.baseUrl + UrlConstant.MFA_DISABLE;
    return this.post(url, {otp});
  }

  /**
   * First-login flow: xác nhận OTP sau khi user quét QR lần đầu.
   * Nếu OTP hợp lệ → BE set mfaFirstLogin=false và cấp OAuth2 token luôn.
   * POST /auth/verify-mfa-first-login  { mfaToken: firstLoginToken, otp }
   */
  public verifyMfaFirstLogin(firstLoginToken: string, otp: string): Observable<any> {
    const url = this.baseUrl + UrlConstant.VERIFY_MFA_FIRST_LOGIN;
    return this.post(url, {mfaToken: firstLoginToken, otp});
  }
}
